import { render } from "./reference-search-item.vue?vue&type=template&id=34d8ae1b&scoped=true"
import script from "./reference-search-item.vue?vue&type=script&lang=js"
export * from "./reference-search-item.vue?vue&type=script&lang=js"

import "./reference-search-item.vue?vue&type=style&index=0&id=34d8ae1b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8ae1b"]])

export default __exports__